import { Model } from '@/app/shared/models/model';

export class ComplementaryModel extends Model {
  public Name!: string;
  public Value!: string;
  public Created!: Date;
  public Updated?: Date;
}
